module.exports = __webpack_public_path__ + "static/cdarma@1x-575599c37dcaed42e03f10600ad37d8c.png";